import { CSS_PARAM, DEFAULT_TOC, TOC_PARAM, VISIT_LINK_BASE } from '../config/quiz';

const buildVisitUrl = (search) => {
  const params = new URLSearchParams(search);
  const toc = params.get(TOC_PARAM) || DEFAULT_TOC;
  params.delete(CSS_PARAM);
  const query = params.toString();

  return `${VISIT_LINK_BASE}/${toc}${query ? `?${query}` : ''}`;
};

export default buildVisitUrl;
